export default {"src":"/_next/static/media/info-icon.790c827d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};